import { createEffect, sample } from 'effector';
import { $queryParams } from 'models/location';

import LoginAsUserService from 'services/LoginAsUserService';

sample({
    clock: $queryParams.map((params) => params['resumeAsAdvisor']).map(Boolean),
    filter: Boolean,
    fn: () => window.location.href,
    target: createEffect(LoginAsUserService.resume),
});
